<template>
  <div>
    <div v-if="visibleTitle">
      <div>
        <h5><i class="dot"></i>{{ title }}</h5>
      </div>
    </div>
    <div class="writeGridContainer mt-4">
      <slot name="after-custom-row"></slot>
      <fragment v-for="type in types" :key="type">
        <!--        field_name -->
        <div v-if="type === 'field_name'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">{{ fieldName ? fieldName : fieldLabel }}</div>
          <div v-if="isPrint" class="print-input">{{ form.field_name }}</div>
          <field-selector v-else class="w-full" v-model="form.field_id" :field-name="form.field_name" :readonly="board.readonly" @select="onSelectFieldSelector" :use-tab-codes="useTabCodes" />
        </div>

        <!--        department -->
        <div v-if="type === 'department'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.department }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.department }}
          </div>
          <ml-input v-else class="w-full" :value="form.department" :readonly="true" />
        </div>

        <!--        com_name -->
        <div v-if="type === 'com_name'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.com_name }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.section }}
          </div>
          <ml-input v-else class="w-full" :value="form.section" :readonly="true" />
        </div>

        <!--        rank -->
        <div v-if="type === 'rank'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.rank }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.rank }}
          </div>
          <ml-input v-else class="w-full" :value="form.rank" :readonly="true" />
        </div>

        <!--        writer_name -->
        <div v-if="type === 'writer_name'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.writer_name }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.writer_name }}
          </div>
          <ml-input v-else class="w-full" :value="form.writer_name" :readonly="true" />
        </div>

        <!--        date -->
        <div v-if="type === 'date'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.date }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.date }}
          </div>
          <date-selector v-else class="w-full" :value="form.date" :readonly="dateReadonly" />
        </div>

        <!--        수정일 추가 -->
        <div v-if="type === 'updated_at'" class="grid-column-content" :style="isMobile && !useMobileTypes(type) ? { display: 'none' } : {}" vs-align="center">
          <div class="title">
            {{ renderTypeslabel.updated_at }}
          </div>
          <div v-if="isPrint" class="print-input">
            {{ form.updated_at }}
          </div>
          <date-selector v-else class="w-full" :value="form.updated_at" :readonly="true" />
        </div>
      </fragment>

      <div v-for="option of options" :key="option.label" v-show="option.type !== 'alert'">
        <div :style="option.labelStyle" class="title">{{ option.label }}</div>
        <div v-if="isPrint">
          <div class="print-input">
            {{ form[`${option.label}`] }}
          </div>
        </div>
        <div v-else class="overflow-visible">
          <date-selector v-if="option.type === 'date'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly || option.readonly" />
          <ml-input v-else-if="option.type === 'text'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly" />
          <disaster-class-selector v-else-if="option.type === 'disaster'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly" :multiple="option.multiple" />
          <time-selector v-else-if="option.type === 'time'" class="w-full flex-1" v-model="form[`${option.label}`]" :readonly="board.readonly || readonly" />
          <vs-select v-else-if="option.type === '요일'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
            <vs-select-item v-for="option in ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일']" :key="option" :text="option" :value="option" />
          </vs-select>
          <vs-select v-else-if="option.type === '날씨'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
            <vs-select-item v-for="option in ['맑음', '흐림', '눈', '비']" :key="option" :text="option" :value="option" />
          </vs-select>
          <file-uploader v-else-if="option.type === 'file'" v-model="form[`${!!option.value ? option.value : option.label}`]" />
        </div>
        <!-- <disaster-class-selector class="w-full" :readonly="board.readonly || readonly" :multiple="multipleDisaster" /> -->
      </div>
      <div v-if="!isPrint && vislbleAlert && (optionsType.includes('alert') || hostname == 'nhsafe-dev.maot.co.kr' || hostname == 'nhsafe.maot.co.kr')" class="xl:col-span-12">
        <div class="title">알림 대상자 선택</div>
        <AlertUserSelector class="w-full" v-model="form.notification" :readonly="board.readonly || readonly" />
      </div>
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import FileUploader from "@/components/FileUploader";
import config from "/public/config";

export default {
  name: "FieldSelectModule",
  components: {
    TimeSelector,
    DisasterClassSelector,
    DateSelector,
    FieldSelector,
    AlertUserSelector,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    board: Object,
    value: Object,
    fieldName: String,
    visibleTitle: {
      type: Boolean,
      default: () => true,
    },
    vislbleAlert: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: () => "기본정보",
    },
    options: {
      type: Array,
      default: () => [{ type: "alert", label: "알림 대상자 선택" }],
    },
    date: {
      type: String,
      default: () => {
        return new Date().format("yyyy-MM-dd");
      },
    },
    types: {
      type: Array,
      default: () => {
        return ["field_name", "writer_name", "date"];
        // return ["field_name", "department", "com_name", "rank", "writer_name", "date"];
      },
    },

    // props.types 에서 모바일에서 표시할 항목을 선택할 수 있도록 추가
    mobileTypes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dateReadonly: {
      type: Boolean,
      default: () => true,
    },
    typeslabel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    useTabCodes: Array,
  },
  computed: {
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    isMobile() {
      return !(this.verticalNavMenuWidth === "default");
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    fieldLabel() {
      return "회사명";
      // 현재 프로젝트 타입이 정확하게 매칭되어있지 않음 ('내부종사자' 로 설정되어있다)
      // if (this.projectInfo.project_type === "Standard Ver") {
      //   //ProjectId = 1
      //   return "사업장명";
      // } else if (this.projectInfo.project_type === "Data Base Team") {
      //   //ProjectId = 2
      //   return "사업장명";
      // } else if (this.projectInfo.project_type === "파트너입찰(1억이하)") {
      //   //ProjectId = 3
      //   return "사업장명";
      // } else if (this.projectInfo.project_type === "파트너입찰(1억이상)") {
      //   //ProjectId = 4
      //   return "사업장명";
      // } else if (this.projectInfo.project_type === "삼성 에스원") {
      //   //ProjectId = 5
      //   return "사업장명";
      // }
    },
    optionsType() {
      return this.options.map((op) => op.type);
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
          this.form.field_id = 0;
        } else {
          this.form.date = this.value.date;
          this.form.field_id = this.value.field_id;
          this.form.field_name = this.value.field_name;
          this.form.project_name = this.value.project_name;
          this.form.field_address = this.value.field_address;
          this.form.department = this.value.department;
          this.form.section = this.value.section;
          this.form.com_name = this.value.com_name;
          this.form.rank = this.value.rank;
          this.form.writer_name = this.value.writer_name;
          this.form.검토일 = this.value.검토일;
          this.form.조사일 = this.value.조사일;
          this.form.점검일 = this.value.점검일;
          this.form.보수일 = this.value.보수일;
          this.form.진단일 = this.value.진단일;
          this.form.보강일 = this.value.보강일;
          this.form.교체일 = this.value.교체일;
          this.form.평가일 = this.value.평가일;
          this.form.점검장소 = this.value.점검장소;
          this.form.보수장소 = this.value.보수장소;
          this.form.재해형태 = this.value.재해형태;
          this.form.진단장소 = this.value.진단장소;
          this.form.보강장소 = this.value.보강장소;
          this.form.교체장소 = this.value.교체장소;
          this.form.평가자 = this.value.평가자;
          this.form.공정내용 = this.value.공정내용;

          this.form.총원 = this.value.총원;
          this.form.작업내용 = this.value.작업내용;
          this.form.점검시간 = this.value.점검시간;
          this.form.공정명 = this.value.공정명;

          this.form.notification = this.value.notification;

          // updated_at 추가
          const postId = this.$route.params.postId;
          const boardList = this.$store.state.board.list;
          for (const boardData of boardList) {
            if (boardData.id === postId) {
              this.form.updated_at = boardData.updated_at;
            }
          }
        }

        for (const option of this.options) {
          const _key = `${option.value ? option.value : option.label}`;
          if (this.value) {
            this.form[_key] = this.value[_key] ? this.value[_key] : "";
          } else {
            this.form[_key] = "";
          }
        }
      },
    },
    form: {
      immediate: false,
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
    typeslabel: {
      immediate: true,
      deep: true,
      handler(value) {
        this.renderTypeslabel = { ...this.renderTypeslabel, ...value };
      },
    },
    projectInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.project_name = value.field_name;
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler() {
        // post 를 불러왔을 경우에는
        // post 에 저장되어 있는 데이터를 사용하기 때문에,
        // board 의 정보로 데이터를 저장하지 않는다.
        if (!this.value || !this.value.com_name) {
          this.form.department = this.board.writer.department;
          this.form.section = this.board.writer.section;
          this.form.com_name = this.board.writer.com_name;
          this.form.rank = this.board.writer.rank;
          this.form.writer_name = this.board.writer.name;

          if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
            this.form.field_id = 0;
          } else {
            this.form.field_id = this.value.field_id;
            this.form.field_name = this.value.field_name;
            this.form.field_address = this.value.address;
          }

          for (const option of this.options) {
            if (this.value) {
              this.form[`${option.label}`] = this.value[`${option.label}`] ? this.value[`${option.label}`] : "";
            } else {
              this.form[`${option.label}`] = "";
            }
          }
        }
      },
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,

      renderTypeslabel: {
        field_name: "사업장명",
        department: "소속명",
        com_name: "부서명",
        rank: "직책",
        writer_name: "작성자",
        date: "작성일",
        updated_at: "최종수정일",
      },
      form: {
        field_id: 0,
        project_name: "",
        field_name: "",
        field_address: "",
        department: "",
        section: "",
        com_name: "",
        rank: "",
        writer_name: "",
        date: this.date,
        검토일: "",
        조사일: "",
        점검일: "",
        보수일: "",
        진단일: "",
        보강일: "",
        교체일: "",
        평가일: "",
        점검장소: "",
        보수장소: "",
        재해형태: "",
        진단장소: "",
        보강장소: "",
        교체장소: "",
        평가자: "",
        공정내용: "",

        총원: "",
        작업내용: "",
        점검시간: "",
        공정명: "",

        updated_at: "",

        notification: [],
      },
    };
  },

  async created() {
    const projectId = this.$route.params.proj_id;
    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: projectId });
  },

  methods: {
    useMobileTypes(type) {
      if (this.mobileTypes.length > 0) {
        return this.mobileTypes.includes(type);
      }
      return true;
    },
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.form.field_address = value.address;

      this.$emit("selectField", value);
    },
  },
};
</script>
